import { useAccountStore } from "@/store/account";
import { initializeSession } from "./auth";
import { insertprofile, loadProfile } from "./profile";

export async function bootstrapSession() {
  const account = useAccountStore();

  /*
   * Refresh Token
   */

  const init = await initializeSession();

  if (init !== true) {
    return init.response;
  }

  /*
   * Ambil Profile Laravel
   */

  var profile = await loadProfile(account.user);

  //console.log("PROFILE:", profile);

  if (profile.status !== 200) {
    var resultinsert = await insertprofile();
    if (resultinsert.status !== 200) {
      return {
        status: profile.status,
        message: profile.data?.message,
      };
    }

    profile = resultinsert;
    //console.log("data isi insert profile ",resultinsert);
  }

  /*
   * Simpan ke Pinia
   */

  account.setUser({
    id: profile.data.user.id,
    user: [null,undefined].includes(profile.data.user.user)?profile.data.user.username:profile.data.user.user,
    detailUser: profile.data.user,
    perusahaan: profile.data.perusahaan,
    role: profile.data.user.role_name,
  });

  return {
    status: 200,
  };
}
